"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var modalStyles = makeStyles_1.default(function () { return ({
    container: {
        boxShadow: '2px 2px 10px 2px rgba(0,0,0,0.7)',
    },
}); }, { name: 'Checkout_Modal' });
exports.default = modalStyles;
